import { types } from '../types'

export const saveBusinessInfoAction = (params) => {
    return {
        type: types.COMPANY_INFO_SAVE_REQUEST,
        params,
    }
}

export const getBusinessInfoAction = (params) => {
    return {
        type: types.GET_COMPANY_INFO_REQUEST,
        params,
    }
}


export const resetCompanyINfoAction = (params) => {
    return {
        type: types.COMPANY_INFO_RESET_PROPS,
        params
    }
}

